import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { ListTable } from "../Table/listTable/listTable";
import {
  useGetAllResults,
  useRemoveResult,
} from "../../hooks/resultsHooks/results.hooks";
import { resultListTitles } from "../../Constants/tableTitles/ListTableTitle/ResultList.titles";
import { transformResultListTableData } from "../../Services/transformer/transformResultListTableData";
import { getValue } from "../../utils/object.utils";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../Constants/paths";
import { ResultNavigationHeader } from "../../Constants/Enums/navigationHeader.enum";
import { EditResultModal } from "./EditResultModal";
import { RemoveResultModal } from "./RemoveResultModal";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../Redux/Slices/alert.slice";
import { parseApiError } from "../../Helper/apiError.helper";

export const ListResults = () => {
  const dispatch = useDispatch();

  const [pageToSearch, setPageToSearch] = useState(1);
  const [resultToEdit, setResultToEdit] = useState<any | null>(null);

  const [openRemoveModal, setOpenRemoveModal] = useState<boolean>(false);
  const [resultToRemove, setResultToRemove] = useState<any | null>(null);

  const { isLoading: isBrancheListLoading, data } = useGetAllResults({
    page: pageToSearch,
  });

  const { isLoading: isRemoving, mutate: removeResult } = useRemoveResult({
    onSuccess: () => {
      dispatch(setSuccessMessage("Result removed successfully."));
      setOpenRemoveModal(false);
    },
    onError: (error: Error) => {
      dispatch(setErrorMessage(parseApiError(error)));
    },
  });

  const navigate = useNavigate();

  const handleResultSelected = (selectedResult: any) => {
    const resultId = getValue(selectedResult, "id");

    if (!resultId) return;

    navigate({
      pathname: Paths.ResultDetails,
      search: `?section=${ResultNavigationHeader.SUDENT_RESULT_DETAIL}&resultId=${resultId}`,
    });
  };

  const handleResultRemove = () => {
    const resultId = getValue(resultToRemove, "id");

    if (!resultId) return null;

    removeResult(resultId);
  };

  return (
    <>
      <ListTable
        titles={resultListTitles}
        data={data?.result}
        isDataLoading={isBrancheListLoading}
        transformFn={transformResultListTableData}
        pagination={{
          onPageChange: (pageNo) => {
            setPageToSearch(pageNo);
          },
          totalPage: data?.lastPage,
        }}
        moreOptons={{
          onEdit: (rowData: any) => {
            setResultToEdit(rowData);
          },
          onRemove: (rowData: any) => {
            setResultToRemove(rowData);
            setOpenRemoveModal(true);
          },
        }}
        onRowClick={handleResultSelected}
      />

      <EditResultModal
        resultId={getValue(resultToEdit, "id")}
        resultDetail={
          resultToEdit
            ? {
                publishDate: getValue(resultToEdit, "rawPublishDate"),
                resultType: getValue(resultToEdit, "resultType"),
                totalAttendance: getValue(resultToEdit, "totalAttendance"),
              }
            : null
        }
        open={!!resultToEdit}
        onClose={() => setResultToEdit(null)}
      />

      <RemoveResultModal
        open={openRemoveModal}
        handleResultRemove={handleResultRemove}
        onClose={() => {
          setOpenRemoveModal(false);
        }}
        selectedResultToRemove={resultToRemove}
        isProcessingConfirmation={isRemoving}
      />
    </>
  );
};
